import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ActionButtons from "./response-information-action-buttons.vue";
import SubmissionStatusBadge from "./submission-status-badge.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ResponseInformation",
  components: {
    ActionButtons,
    SubmissionStatusBadge
  },
  props: {
    lenderResponses: {
      type: Array,
      required: true
    },
    mpp: {
      type: Object,
      required: true
    },
    generatingMpp: {
      type: Boolean,
      default: false
    },
    mppDisabled: {
      type: Boolean,
      default: false
    },
    accessRights: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      tableColumns: ["date", "lender", "mortgageType", "expiryDate", "responseType", "responseDate", "actions", "id", "lenderCommitmentDocumentS3Key"]
    };
  },
  computed: {
    options() {
      return {
        sortable: [],
        filterable: false,
        showChildRowToggler: false,
        perPage: 999999,
        hiddenColumns: ["id", "lenderCommitmentDocumentS3Key"],
        orderBy: {
          ascending: false,
          column: "date"
        },
        customSorting: {
          date(ascending) {
            return (a, b) => {
              const dateA = new Date(a.createdAt);
              const dateB = new Date(b.createdAt);
              if (ascending) return dateA >= dateB ? 1 : -1;
              return dateA <= dateB ? 1 : -1;
            };
          }
        },
        headings: {
          date: `${this.$t("global.words.date")}/${this.$t("global.words.time")}`,
          lender: this.$t("global.doorr.lender"),
          mortgageType: this.$t("application-flow.labels.mortgageType"),
          expiryDate: this.$t("direct-to-lender.lenderResponse.expiryDate"),
          responseType: this.$t("direct-to-lender.lenderResponse.responseType"),
          responseDate: this.$t("direct-to-lender.lenderResponse.responseDate"),
          actions: this.$t("global.words.actions"),
          id: "",
          lenderCommitmentDocumentS3Key: ""
        },
        columnsClasses: {
          actions: "hidden-heading"
        },
        texts: {
          count: ""
        },
        tabbable: false,
        skin: "table table-hover"
      };
    }
  },
  methods: {
    showDetailsFocusedSection(data) {
      this.$emit("response-details", {
        data,
        focusSection: true
      });
    },
    handleClick(data, index, event) {
      this.$emit(`response-${event}`, {
        data,
        index
      });
    },
    isDeclined(status) {
      return status === "declined";
    },
    stopLoader({
      type,
      status,
      index
    }) {
      if (type === "accept") this.$refs[`actionButtons-${index}`].stopAcceptLoader();else this.$refs[`actionButtons-${index}`].stopPreviewLoader(status);
    },
    isMppAvailable({
      submissionId
    }) {
      return !!this.mpp.byId[submissionId];
    },
    isMppDocAvailable({
      submissionId
    }) {
      var _this$mpp$byId$submis;
      return !!((_this$mpp$byId$submis = this.mpp.byId[submissionId]) != null && _this$mpp$byId$submis.documents.length);
    },
    mppFailed({
      submissionId
    }) {
      var _this$mpp$byId$submis2;
      return ((_this$mpp$byId$submis2 = this.mpp.byId[submissionId]) == null ? void 0 : _this$mpp$byId$submis2.mppRequestStatus) === "fail";
    },
    mppMessages(row) {
      const {
        mppFailMessages,
        mppInfoMessages = []
      } = this.mpp.byId[row.submissionId] || {};
      const failMessagesWithError = (mppFailMessages == null ? void 0 : _reduceInstanceProperty(mppFailMessages).call(mppFailMessages, (acc, current) => {
        acc.push(_objectSpread(_objectSpread({}, current), {}, {
          error: true
        }));
        return acc;
      }, [])) || [];
      return [...failMessagesWithError, ...mppInfoMessages];
    }
  }
});